import { render, staticRenderFns } from "./add-viilearn-common-modal.vue?vue&type=template&id=31b68a7a"
import script from "./add-viilearn-common-modal.vue?vue&type=script&lang=js"
export * from "./add-viilearn-common-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports